/**
 *  Formats and removes whitespace and line breaks from literals
 * @return string without whitespace and line breaks
 */
export const formatClass = literal => {
  return literal.replace(/\s\s+/g, ' ');
};



// WEBPACK FOOTER //
// ./src/main/ui/react/shared/helpers/Formatters.js